import { Box, Typography } from '@mui/material';
import React from 'react';
import FormTextField from '../../../../../shared/FormTextField';
import CustomInputLabel from '../../../../../../layout/styledcomponents/CustomInputLabel';

export default function NotesSection({ control, watch }: any) {
    return (
        <>
            <Box display='flex' justifyContent='space-between'>
                <CustomInputLabel>Additional Notes</CustomInputLabel>
                {watch('bookingInfo.notes')?.length > 0 && (
                    <Typography variant='caption'>
                        {`Characters left: ${
                            300 - watch('bookingInfo.notes').length
                        }`}
                    </Typography>
                )}
            </Box>
            <FormTextField
                name='bookingInfo.notes'
                control={control}
                multiline
                rows={4}
                inputProps={{ maxLength: 300 }}
            />
        </>
    );
}
